export const storeUtmParameters = () => {
  // Fonction pour récupérer les paramètres d'URL
  const getUrlParameter = (sParam) => {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : sParameterName[1].replace(/\+/g, " ");
      }
    }
    return undefined; // Retourne undefined si le paramètre n'est pas trouvé
  };

  // Récupérer les valeurs des UTM
  let utm_source = getUrlParameter("utm_source");
  let utm_medium = getUrlParameter("utm_medium");
  let utm_campaign = getUrlParameter("utm_campaign");

  // Récupérer les champs de devis
  let input_source = document.querySelector('input[name="utm_source"]');
  let input_medium = document.querySelector('input[name="utm_medium"]');
  let input_campaign = document.querySelector('input[name="utm_campaign"]');

  // Vérifier si les données existent déjà dans sessionStorage
  if (
    sessionStorage.getItem("utm_source") &&
    sessionStorage.getItem("utm_medium")
  ) {
    // Si les données sont différentes -> mettre à jour
    if (
      utm_source !== sessionStorage.getItem("utm_source") &&
      utm_source !== undefined
    ) {
      sessionStorage.setItem("utm_source", utm_source);
    }
    if (
      utm_medium !== sessionStorage.getItem("utm_medium") &&
      utm_medium !== undefined
    ) {
      sessionStorage.setItem("utm_medium", utm_medium);
    }
    if (
      utm_campaign !== sessionStorage.getItem("utm_campaign") &&
      utm_campaign !== undefined
    ) {
      sessionStorage.setItem("utm_campaign", utm_campaign);
    }
  } else {
    // Insérer les nouvelles données
    sessionStorage.setItem("utm_source", utm_source);
    sessionStorage.setItem("utm_medium", utm_medium);
    sessionStorage.setItem("utm_campaign", utm_campaign);
  }

  // Gérer les valeurs undefined
  if (utm_source === undefined || utm_source === "undefined") {
    utm_source = " ";
  }
  if (utm_medium === undefined || utm_medium === "undefined") {
    utm_medium = " ";
  }
  if (utm_campaign === undefined || utm_campaign === "undefined") {
    utm_campaign = " ";
  }

  if (input_source && sessionStorage.getItem("utm_source") != "undefined") {
    input_source.value = sessionStorage.getItem("utm_source");
  }
  if (input_medium && sessionStorage.getItem("utm_medium") != "undefined") {
    input_medium.value = sessionStorage.getItem("utm_medium");
  }
  if (input_campaign && sessionStorage.getItem("utm_campaign") != "undefined") {
    input_campaign.value = sessionStorage.getItem("utm_campaign");
  }
};
